import { Button } from '@/components/atoms/Button'
import { useI18n } from '@/locales/client'
import useCartStore from '@/stores/CartStore'
import useLimitStore from '@/stores/LimitStore'

export default function StartOverButton() {
  const t = useI18n()
  const resetCart = useCartStore(store => store.reset)
  const resetLimit = useLimitStore(store => store.reset)

  const handleClick = () => {
    resetCart()
    resetLimit()
  }

  return (
    <Button
      variant="link"
      className="text-center text-base font-semibold leading-6 text-rsf-blue underline hover:text-rsf-blue/80"
      onClick={handleClick}
    >
      {t('startOverButton')}
    </Button>
  )
}
